import { render, staticRenderFns } from "./BdForget.vue?vue&type=template&id=a08f669e&scoped=true&"
import script from "./BdForget.vue?vue&type=script&lang=js&"
export * from "./BdForget.vue?vue&type=script&lang=js&"
import style0 from "./BdForget.vue?vue&type=style&index=0&id=a08f669e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08f669e",
  null
  
)

export default component.exports